// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"da98cf5f","977":"e4f27a88"}[chunkId] + ".chunk.js");